// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_Y1QBM {
  position : relative;
  display : flex;
  flex-direction : row;
  flex-wrap : nowrap;
}

.headerCell_E8zRc {
  overflow : visible !important;
  flex-shrink : 0;
  flex-grow : 0;
}

.sticky_vQETj {
  position : sticky;
  left : 0;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-linear-view-elements/lib/MomentHeader.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,QAAQ;AACV","sourcesContent":[".header {\n  position : relative;\n  display : flex;\n  flex-direction : row;\n  flex-wrap : nowrap;\n}\n\n.headerCell {\n  overflow : visible !important;\n  flex-shrink : 0;\n  flex-grow : 0;\n}\n\n.sticky {\n  position : sticky;\n  left : 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `header_Y1QBM`,
	"headerCell": `headerCell_E8zRc`,
	"sticky": `sticky_vQETj`
};
export default ___CSS_LOADER_EXPORT___;
